var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg210221N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5DCE2",
    d: "M38.605,24.673 L37.705,24.259 L37.632,23.27 C37.396,20.087 34.708,17.593 31.511,17.593 C30.947,17.593 30.376,17.673 29.813,17.831 L28.826,18.107 L28.129,17.357 C26.584,15.695 24.396,14.742 22.125,14.742 C18.237,14.742 14.857,17.513 14.092,21.332 L13.913,22.226 L13.064,22.564 C10.199,23.699 8.274,26.528 8.274,29.604 C8.274,33.78 11.674,37.18 15.851,37.18 L35.879,37.18 C39.488,37.18 42.424,34.24 42.424,30.626 C42.423,28.078 40.925,25.741 38.605,24.673"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7694B4",
    d: "M33.349,13.315 C30.662,9.925 28.98,4.037 32.765,0.0399999991 C31.309,0.457999999 29.904,1.153 28.639,2.15 C26.481,3.848 25.225,6.177 24.748,8.641 C24.535,10.355 24.495,11.988 24.537,13.56 C26.338,14.021 27.995,14.98 29.279,16.358 L29.325,16.408 L29.388,16.39 C30.09,16.194 30.804,16.094 31.511,16.094 C35.464,16.094 38.785,19.136 39.169,23.048 C40.695,22.753 42.18,22.137 43.527,21.076 C44.795,20.081 45.799,18.881 46.547,17.561 C41.771,20.297 36.359,17.111 33.349,13.315"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF7800",
    points: "32.037 43.465 29.222 43.422 31.53 39.385 27.967 39.415 24.944 45.438 27.576 45.438 23.88 54.567"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg210221N);
export default __webpack_public_path__ + "static/media/210_221n.4ef4815d38464381de1c2b26d8342f72.svg";
export { ForwardRef as ReactComponent };